import { NO_DATA_MESSAGE, PersonHttpHelper } from '../../utils/HttpHelper';

const postPersonAcknowledgements = (id, payloadArray, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const idForUrl = id ? encodeURIComponent(id) : 'NaN';
    const url = `/PersonAcknowledgement/Member/${idForUrl}/Forms`;
    PersonHttpHelper(url, 'POST', payloadArray)
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoaded: true,
            isSaving: false,
            isSaved: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isSaving: false,
          isSaved: true,
          message: message
        });
      });
  }
};

export default postPersonAcknowledgements;
